import axios from "axios";
import { constants } from "../context/keys";
const BASE_URL = process.env.REACT_APP_API_URL_V2 + "/api/v1";

export function getV2(path) {
    let headers = getTokensV2();
    return axios.get(BASE_URL + path, { headers: headers });
}

export function loginV2(body) {
    return axios.post(BASE_URL + "/auth/admin/email/login", body);
}

export function getTokensV2() {
    return {
        Authorization: "Bearer " + sessionStorage.getItem(constants.tokenV2),
    };
}

export function postV2(path, body) {
    let headers = getTokensV2();
    return axios.post(BASE_URL + path, body, { headers: headers });
}

export function delV2(path, id) {
    let headers = getTokensV2();
    return axios.delete(BASE_URL + path + id, { headers: headers });
}

export function updateV2(path, body) {
    let headers = getTokensV2();
    return axios.put(BASE_URL + path, body, { headers: headers });
}

export function patchV2(path, body) {
    let headers = getTokensV2();
    return axios.patch(BASE_URL + path, body, { headers: headers });
}

export function postImageV2(path, body) {
    let headers = getTokensV2();
    headers = { ...headers, "Content-Type": "multipart/form-data" };
    return axios.post(BASE_URL + path, body, { headers: headers });
}

export function updateImageV2(path, body) {
    let headers = getTokensV2();
    headers = { ...headers, "Content-Type": "multipart/form-data" };
    return axios.put(BASE_URL + path, body, { headers: headers });
}
